import { TacoRating } from '@appsumo/dorado-react';
import clsx from 'clsx';
import ToggleText from '~/components/ui/ToggleText';
import { formatToHumanReadableDate } from '~/lib/util';

export interface IDiscussionReviewInfo {
  rating: number;
  publishDate: Date;
  dealPlan: string;
  title: string;
  content: string;
  showText?: boolean;
  isCollapsed?: boolean;
}

function ReviewInfo({
  rating,
  publishDate,
  dealPlan,
  title,
  content,
  showText,
  isCollapsed = false,
}: IDiscussionReviewInfo) {
  return (
    <div data-testid="discussion-review-info" className="w-full">
      <TacoRating averageRating={rating} size="lg" />

      <div className="space-y-1.5">
        <div className="mt-2 flex items-center gap-2 text-sm text-grace">
          <span>
            {formatToHumanReadableDate(publishDate.toISOString(), {
              month: 'short',
            })}
          </span>
          {dealPlan && (
            <>
              <span
                className="h-1.5 w-1.5 rounded-full bg-gravel"
                aria-hidden="true"
              />
              <span>{dealPlan}</span>
            </>
          )}
        </div>

        <p
          className={clsx(
            'font-header text-xl font-bold leading-6 text-black-pearl',
            { 'line-clamp-1': isCollapsed },
          )}
        >
          {title}
        </p>
        {showText && <ToggleText text={content} className="text-midnight" />}
      </div>
    </div>
  );
}

export default ReviewInfo;
